
import barba from '@barba/core';
import Swiper from 'swiper';

export default class{

	constructor(){

        barba.hooks.beforeOnce((data) => {
            this.heroSlider()
            this.blogSlider()

        })
        barba.hooks.after((data) => {
            this.heroSlider()
            this.blogSlider()
        });
        
    }
    heroSlider(){
        new Swiper ('#l-hero__slider',{
            loop: true,
            speed:100000,
            easing:"linear",
            allowTouchMove :false,
            simulateTouch:false,
            autoplay: {
                delay: 0,
                disableOnInteraction:false
            }
        })
    }
    
    blogSlider(){
        // const blog_thumbnails = document.querySelectorAll('.blog-slider-thumbnails a');
        const blogSlider = new Swiper('.js-blog__slider', {
            loop: true,
            speed:400,
            easing:"linear",
            loopAdditionalSlides : 5,
            slidesPerView: 'auto',
            spaceBetween: 20,
            simulateTouch:true,
            centeredSlides: false,
            breakpoints: {
                
                576: {
                    slidesPerView: 'auto',
                    spaceBetween:  40,
                }
            }
        });
    }
}